import { render, staticRenderFns } from "./GatGrid.vue?vue&type=template&id=2523435b&scoped=true&"
import script from "./GatGrid.vue?vue&type=script&lang=js&"
export * from "./GatGrid.vue?vue&type=script&lang=js&"
import style0 from "./GatGrid.vue?vue&type=style&index=0&id=2523435b&prod&scoped=true&lang=scss&"
import style1 from "./GatGrid.vue?vue&type=style&index=1&id=2523435b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2523435b",
  null
  
)

export default component.exports